import { useState } from "react";
import { BlurModal } from "../../page/components/BlurModal/BlurModal";
import { GeneralModal } from "../GeneralModal/GeneralModal";
import styled from "styled-components";

export const DeleteModal = ({
  closeDeleteModal,
  handleDeleteModal,
  nameOfView,
  labelForConfirmCheck,
}) => {
  const [isChecked, setIsChecked] = useState(false);

  const handleChange = e => {
    setIsChecked(e.target.checked);
  };
  return (
    <BlurModal>
      <GeneralModal
        isChecked={isChecked}
        titleOfModal="Delete Confirmation"
        btnName="Delete"
        closeModal={closeDeleteModal}
        handleModalWork={handleDeleteModal}
        widthOfGeneralModal="30vw"
      >
        <p>{nameOfView} </p>

        <LabelForConfirm className="confirmDeletion">
          <input type="checkbox" onChange={handleChange} checked={isChecked} />
          {labelForConfirmCheck}{" "}
        </LabelForConfirm>
      </GeneralModal>
    </BlurModal>
  );
};

export const LabelForConfirm = styled.label`
  display: flex;
  gap: 4px;
  align-items: center;
  background-color: #f5f6f8;
  padding: 4px 8px;
  border-radius: 4px;
  margin: 8px 0;
  font-size: 14px;
  font-weight: 400;
  color: var(--DARK-GREY, #0e0e2c);
  width: max-content;

  input {
    cursor: pointer;
  }
`;
